import { render, staticRenderFns } from "./photoApprove.vue?vue&type=template&id=407c2718&"
import script from "./photoApprove.vue?vue&type=script&lang=js&"
export * from "./photoApprove.vue?vue&type=script&lang=js&"
import style0 from "./photoApprove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports